import {REDIRECT_NEW_ACCOUNTS_TO_MOBILE_WEB_COLONIST_VERSION} from '@colonist/types'
import {ClientUserState} from './ClientUserState.ts'
import {UIDeviceController} from './ui_html/UIDeviceController.ts'
import {UIUrlController} from './ui_html/UIUrlController.ts'
import {StorageWrapper} from './StorageWrapper.ts'
import {UIPortraitModeOptInPopup} from './ui_popup/UIPortraitModeOptInPopup.tsx'
import {UISwitchToPortraitPopup} from './ui_popup/UISwitchToPortraitPopup.tsx'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables.ts'

export class ClientPlatformRedirection {
    static handleAccountRedirection() {
        if(!this.shouldPerformAnyRedirectionToMobilePath()) return

        const isGuestUser = !ClientUserState.userState?.isLoggedIn

        if(isGuestUser) {
            this.handleRedirectNewAccountsToMobileWeb()
            return
        }

        const colonistVersion = ClientUserState.userState?.colonistVersion
        const isNewUser = colonistVersion != undefined && colonistVersion >= REDIRECT_NEW_ACCOUNTS_TO_MOBILE_WEB_COLONIST_VERSION

        if(!isNewUser) return

        this.handleRedirectNewAccountsToMobileWeb()
    }

    static handlePortraitModeEnforcement() {
        if(!this.shouldPerformAnyRedirectionToMobilePath()) return
        if(this.isOnMobilePath()) return
        if(!UIUtilsEjsVariables.portraitModeEnforcementDate) return

        const accepted = StorageWrapper.getPortraitModeEnforcementAccepted()
        if(accepted == true) {
            this.handleRedirectNewAccountsToMobileWeb()
            return
        }
        if(accepted == false) return

        const optInPopup = new UIPortraitModeOptInPopup(() => {
            const switchPopup = new UISwitchToPortraitPopup(() => {
                StorageWrapper.setPortraitModeEnforcementAccepted(false)
            })
            switchPopup.show()
        })
        optInPopup.show()
    }

    private static isUserOnLandingPage(): boolean {
        // Should be similar logic in code/client/web/views/pages/ejs_shared/first-scene-detection.ejs
        if(!UIUrlController.isUrlPathRoot()) return false
        if(window.location.pathname.includes('/mobile')) return false
        if(ClientUserState.userState?.isLoggedIn) return false
        const hasCompletedOneGame = (ClientUserState.userState?.totalCompletedGameCount ?? 0) > 0
        if(hasCompletedOneGame) return false

        return true
    }

    private static shouldPerformAnyRedirectionToMobilePath(): boolean {
        if(!UIDeviceController.isUserOnMobileWebBrowser()) return false
        if(UIDeviceController.isUserOnTabletDevice()) return false
        if(this.isUserOnLandingPage()) {
            const shouldRedirectToRoom = UIUrlController.getRoomIdFromUrl() != undefined
            return shouldRedirectToRoom
        }

        const isRulebookPage = window.location.pathname.includes('/catan-rules')
        if(isRulebookPage) return false

        return true
    }

    private static isOnMobilePath(): boolean {
        return window.location.pathname.includes('/mobile')
    }

    static handleRedirectNewAccountsToMobileWeb() {
        if(this.isOnMobilePath()) return
        StorageWrapper.setPortraitGamePlayEnabled(true)
        const languagePrefix = UIUrlController.getLanguagePrefix()
        const newUrl = languagePrefix + '/mobile' + UIUrlController.getRelativeUrlWithoutLanguagePrefix()
        window.location.href = this.removeTrailingSlash(newUrl)
    }

    private static removeTrailingSlash(url: string): string {
        return url.replace(/\/([?#])/, '$1')
    }
}
